// extracted by mini-css-extract-plugin
module.exports = {"account-setting":"_3-MVqoQmwH","module-name":"_2OUWGsGPOj"};